// extracted by mini-css-extract-plugin
export var container = "FeaturedPostsVerticalSection-module--container--2c3cc";
export var posts = "FeaturedPostsVerticalSection-module--posts--5dbdd";
export var section = "FeaturedPostsVerticalSection-module--section--fb079";
export var title = "FeaturedPostsVerticalSection-module--title--8c268";